import { ChangeDetectorRef, Component, Input, OnInit,ViewRef,Output,EventEmitter } from '@angular/core'
import { Stringable, StringableValues } from '../../../../../../common/stringable.decorator'
import { JSONRpcResponse } from '../../../../../../Interfaces/JSONRpcResponse'
import { FormDialogFormulaireWithSFComponent } from '../../../../../../motor-form-atyl/form-atyl-components/form-dialog/form-dialog-formulaire-with-sf/form-dialog-formulaire-with-sf.component'
import { DialogService, DossierService, VisiteService,InstructionService,StateService } from '../../../../../../services'
import { VisiteActionsDialog } from '../../../../../partials/content/actions/visite-actions-dialog/visite-actions-dialog.component'
import { VisiteFormulairesListing } from '../../../../../partials/content/listing/visite-formulaires-listing/visite-formulaires-listing.component'
import { ActivatedRoute, Router } from "@angular/router"
import { PanierLine} from  '../../../../../../Interfaces/Panier'
import { BehaviorSubject,Subject } from 'rxjs'

const KEY = 'visite-single'

@Component({
	selector: 'atyl-visite-single-partials',
	templateUrl: './visite-single.component.html',
	styleUrls: ['./visite-single.component.scss']
})
@Stringable({
	path: 'views/pages/consultation/visites/single',
	key: KEY,
})
export class VisiteSingleComponent implements OnInit {

	/**
	 * element == single visite from the parent visitesObj in the visite-list component
	 */
	@Input() element: any
	@Input() elementPanier: PanierLine[]=[];
	@Input() consultation : any;
	@Input() etatList:any[]=[];
    @Input() visiteToOpen: BehaviorSubject<number>;

	visiteExpand:boolean = false;
	
	eventsLoadingCourrierSubject: Subject<boolean> = new Subject<boolean>();
	eventsLoadingDocumentSubject: Subject<boolean> = new Subject<boolean>();
	
	
	@StringableValues(KEY) strings: any
	currentInformations: any = {
        ID: 0,
		professionels: [],
		formulaires: [],
		demandes: [],
		accompagnants: [],
		instructions: [],
		actions: [],
		expanded: false,
		expandedAccompagnants: false,
	};
	tiersID: any;
	dossier: any;
    page: any;
    selectInstruc:any;
    viewInstru:boolean=false;
    viewDos:boolean=false;
    rightsInstru:any;
    
    user:any;
    
    @Output() visiteClosed = new EventEmitter<any>();
	@Output() visiteOpened = new EventEmitter<any>();
	checboxed:boolean=true;
	@Output() selected:any = new EventEmitter<any>();

    
	constructor(
		private changeDetectorRef: ChangeDetectorRef,
		private visiteService: VisiteService,
		private dossierService: DossierService,
		private dialogService: DialogService,
		private router: Router,
		private activatedRoute: ActivatedRoute,
		private instructionService: InstructionService,
		private stateService:StateService
	) { }

	ngOnChanges() {
	}
	ngOnInit() {
		if (this.element && this.element.tiers!=undefined) {
		  this.tiersID = this.element.tiers.ID
		  //console.log('this.element', this.element, this.tiersID,'\nconsultation',this.consultation);
		}
		
		
		this.stateService.user.subscribe((user) => {
            if (user) {
                this.user = user
                this.element = this.setObjectUserRights(this.element,"visite");
            }

        })

        console.log('ngOnInit (single) consultaion:',this.consultation,this.visiteExpand);

		this.visiteToOpen.subscribe(visiteId=>{
			if(this.element.ID == visiteId){
				this.visiteExpand = true;
				this.changeChild(this.element);
				this.visiteOpened.emit();
			}
		})
   
        
	}
	changeChild(child: any) {
		this.visiteService.getFormulaireDemande(child.ID).subscribe((visit_demande: JSONRpcResponse) => {
				    console.log("VisiteSingleComponent getFormulaireDemande",visit_demande)
					
					if (visit_demande.result) {
					    if (visit_demande.result.demandes!=undefined)
							child.demandes=visit_demande.result.demandes;
						if (visit_demande.result.formulaires!=undefined)
								child.formulaires=visit_demande.result.formulaires;
						this.eventsLoadingCourrierSubject.next(true);
						this.eventsLoadingDocumentSubject.next(true);
									
						
				this.dossierService.getTiersDossier(this.tiersID).subscribe((res: JSONRpcResponse) => {
						this.dossier = res.result
						this.viewDos=true
						this.changeDetectorRef.detectChanges()
					})
					
					if (child.tiers) {
						this.tiersID = child.tiers.ID
					}
					
					this.viewInstru=false;
					console.log("child ",child)
					this.currentInformations = {}
					this.currentInformations.ID=child.ID
					this.currentInformations.formulaires = child.formulaires
					this.currentInformations.demandes = child.demandes
					this.currentInformations.accompagnants = child.accompagnants
					this.currentInformations.instructions = child.instructions
					
					let line:PanierLine=new PanierLine();
						line.consultation = this.consultation;
						line.dossier = child.tiers;
						line.visite = child;
			        this.elementPanier.push(line);
					
					
					//this.visiteService.getProfessionnels(child.ID).subscribe((res: JSONRpcResponse) => {
					 	console.log('professionnels', this.consultation)
						this.currentInformations.professionels = this.consultation.professionels.object.map((entry: any) => {
							return {
								ID: entry.ID,
								NOM: entry.NOM,
								PRENOM: entry.PRENOM,
							}
						})
						this.changeDetectorRef.detectChanges()
					//})
					this.getActions(child.ID);
					this.changeDetectorRef.detectChanges();
					
					this.eventsLoadingCourrierSubject.next(true);
					this.eventsLoadingDocumentSubject.next(true);
											
			}
			
		 })		
	}
	
	
	closePanel(child:any) {
		this.visiteClosed.emit(child);
	}
	
	getActions(id: any) {
		this.visiteService.getActions(id).subscribe((res: JSONRpcResponse) => {
			this.currentInformations.actions = res.result.map((entry: any) => {
				return {
					ID: entry.ID,
					libelle: entry.libelle,
					key: entry.key,
				}
			})
		})
	}
	addFormulaire(event: any) {
		this.dialogService.open(VisiteFormulairesListing, {
			data: {
				visite: this.element
			},
			draggable: true,
			minimizable: true,
			maximizable: true,
		}, (res: any) => {
			if (res) {
				this.reloadVisite()
				this.changeDetectorRef.detectChanges()
			}
		})
	}
	openFormulaire(form: any) {
		console.log('openFormulaire', form)
		this.dialogService.open(FormDialogFormulaireWithSFComponent, {
			data: {
				id: form.ID,
				closeWhenValidate: true,
				dossier: this.dossier,
				create: false,
				v3: true,
				title: form.title,
				key: form.form.key,
			},
			height: '90vh',
			width: "90vw",
		})
	}

	openEditVisite(vs:any) {
		
		console.log("openEditVisite",vs,this.dossier);
        this.stateService.pages.subscribe((pages) => {
            pages.forEach(element => {
                if(element.key == "DOSSIERCONSULATION"){
                    this.page = element;
                }
            });
        })
		this.dialogService.open(VisiteActionsDialog, {
			data: {
                title:'Modification d\'un rendez-vous',
				visite: vs,
                dossier: this.dossier,
                page: this.page,
				professionels: this.currentInformations.professionels,
				create: false,
				allowPopup: true,
                editable: this.element.editable
			},
			height: '95vh',
			width: '80vw',
			resizable: true,
			draggable: true,
			minimizable: true,
			maximizable: true,
		})
	}
	reloadVisite() {
		this.visiteService.get(this.element.ID).subscribe((res: JSONRpcResponse) => {
			this.element = res.result
			this.changeChild(this.element)
			this.changeDetectorRef.detectChanges()
		})
	}
	
	openDossier(type, id) {
		this.router.navigate([`/home/dossier/${type}/${id}`], {
			relativeTo: this.activatedRoute,
		})
		
		this.dialogService.closeAll()
	}

	// openDossier() {
    //     console.log('openDossier',this.dossier);
    //     this.router.navigate([`/home/dossier/${this.dossier.tiers.type}/${this.dossier.ID}`], {
    //         relativeTo: this.activatedRoute,
    //     })

	// 	this.dialogService.closeAll()
	// 	// this.stateService.reloadPanier.next(false)
	// 	// this.dialogService.close()
    // }
    
    selectInstruction(instru:any) {
		console.log("selectInstruction",instru);
		//this.selectInstruc=instru.instruction;
		//this.viewInstru=true;
		this.selectInstruc=null;
		this.viewInstru=false;
			this.instructionService.get(instru.instruction.ID).subscribe((res: JSONRpcResponse) => {
				this.selectInstruc=res.result;
				this.selectInstruc.selectedForms=[];
				this.selectInstruc.documents=[];
				this.selectInstruc.courriers=[];
				this.selectInstruc.visites=[];
				this.selectInstruc.consultations=[];
				
				this.selectInstruc.expandForm=true;
				this.selectInstruc.expandCour=true;
				this.selectInstruc.expandDoc=true;
                this.selectInstruc.rightsInstru = instru.rights != undefined
                ? instru.rights
                : {"r":true,"w":true,"x":true} 

				this.viewInstru=true;
				if (this.changeDetectorRef && !(this.changeDetectorRef as ViewRef).destroyed) 
                            this.changeDetectorRef.detectChanges()
				
		})
			
		
		
	}
	
	viewDossier(visite:any) {
		this.viewDos=!this.viewDos;

		if (this.changeDetectorRef && !(this.changeDetectorRef as ViewRef).destroyed) 
                      this.changeDetectorRef.detectChanges()
	}

    setObjectUserRights(obj: any | any[], type: string) {
        if (Array.isArray(obj)) {
            obj.forEach((item: any) => {
                item = this.applyRightsObj(item, type);
            });
        } else {
            obj = this.applyRightsObj(obj, type);
        }
        return obj;
    }
    
    applyRightsObj(obj: any, type: string) {
        let rg: any = {
            r: true,
            w: true,
            x: true
        };
        let key = null;
        
        switch (type) {
            case "visite":
				if (obj.visite!=undefined && obj.visite.consultation.type!=undefined )
                	key = obj.consultation.type.key;
                type="consultation";
                break;
        }
    
        if (this.user.droitsObjets != undefined && this.user.droitsObjets[type] != undefined) {
            if (this.user.droitsObjets[type][key] != undefined) {
                rg = this.user.droitsObjets[type][key];
            }
        }
    
        obj.rights = rg;
    
        if (obj.editable == undefined || obj.editable) {
            obj.editable = rg.w;
        }
        return obj;
    }
	
	changeStatus(event:any,rdv:any) {
				console.log("VisiteSingleComponent Change status",rdv,rdv.etat.key);
				let _options:any={
					visiteetat:rdv.etat.key
					}
				this.visiteService.set(rdv.ID,rdv.consultation.ID,_options).subscribe((res: JSONRpcResponse) => {
					  	if (res.result) {
							
					                this.changeDetectorRef.detectChanges()
						}
					});
	}
	
	isRdvCancelled(rdv_etat)	{
		
			return  (rdv_etat.key=="ANNULE" || rdv_etat.key=="CANCELED" );
			
	}

	checkboxChange(event:any) {
		//	this.checboxed=!this.checboxed;
			if (this.checboxed)
				this.selected.next(this.element);
			else
				this.selected.next(null);
			console.log("checkboxChange",this.checboxed)
		}


	
	openNewRdv(event:any){
		event.stopPropagation();
		if(this.dossier == undefined){
			// this.loadingDossier = true;

			this.dossierService.getTiersDossier(this.tiersID).subscribe((res: JSONRpcResponse) => {
				// this.loadingDossier = false;
				this.dossier = res.result
				this.openDialogNewRDV(this.element,this.dossier);
				this.changeDetectorRef.detectChanges();
			})
		}
		else{
			this.openDialogNewRDV(this.element,this.dossier);
		}
	}
	
	openDialogNewRDV(visite,dossier){
		let dataVs:any= {
			action: "create",
			dataType: "rdv",
			dossier: dossier,
			old_visit: visite,		
			title: "Création d'un rendez-vous",
			create: true,
		};

		this.dialogService.open(VisiteActionsDialog, {
			data: dataVs,
			height: "95vh",
			width: "80vw",
			draggable: true,
			resizable: true,
			minimizable: true,
			maximizable: true,
		}, (res: any) => {
			console.log(res);
		});
	}
}
